import { useTranslation } from 'react-i18next';
import { useTheme } from '@ui/hooks';
import { Logo, PECLogo } from '@ui/icons';

export const PECAppLogo = () => {
  const { t } = useTranslation();
  const { bgColor } = useTheme();

  return (
    <div className="flex items-end gap-1">
      <PECLogo width={100} height="auto" />
      <div className="flex gap-0 items-end mb-[9px]">
        <div className="flex flex-col gap-0 items-center">
          <div className="text-black text-[10px] leading-none">{t('common.powered_by')}:</div>
          <Logo className="h-5 block w-auto text-black" />
        </div>
        <span
          className="text-[7px] leading-none text-base-100 rounded-lg px-1 py-[1px] w-fit"
          style={{ backgroundColor: bgColor }}
        >
          {t('common.beta')}
        </span>
      </div>
    </div>
  );
};
